
















































































import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import Decisions from "@/store/modules/Decisions";
import StorageImage from "@/components/common/StorageImage.vue";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';

const workspaceOptionsModule = getModule(WorkspaceOptions);
const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);

@Component({
    components: {ConfirmationDialog, StorageImage}
})
export default class DecisionManageUsers extends Vue {

    @Model('change')
    decisionTeam!: any;

    @Prop({default: '', type: String})
    header!: string;

    private roles = [
        {display: 'Admin', value: 'ADMIN'},
        {display: 'Editor', value: 'EDIT'},
        {display: 'User', value: 'USER'},
        // {display: 'Read-Only', value: 'READ_ONLY'}
    ]

    private headers: any[] = [
        // { text: 'Rank', value: 'rank', sortable: true, align: ' d-none' },
        {text: 'Image', value: 'image', sortable: false},
        {text: 'Email', value: 'email', sortable: true},
        {text: 'Last Name', value: 'last', sortable: true},
        {text: 'First Name', value: 'first', sortable: true},
        {text: 'Role', value: 'role', sortable: true},
    ];

    private thumbWidth: number = 42;
    private thumbHeight: number = 42;

    private deletingMap: any = {};
    private search: string = '';
    private updatingMap: any = {}

    mounted() {
    }

    get itemsPerPage() {
        return workspaceOptionsModule.manageUsersTableItemPerPage;
    }

    set itemsPerPage(val: any) {
        workspaceOptionsModule.setManageUsersTableItemPerPage(val);
    }

    get isOwner(): boolean {
        return this.userId != null && this.userId === this.decisionOwnerUserId;
    }

    get decisionOwnerUserId(): string | undefined {
        if (decisionsModule.selectedDecision) {
            return decisionsModule.selectedDecision.ownerUserId;
        }
    }

    get decisionAdminUsers(): any[] {
        if (decisionsModule.selectedDecisionUsers) {
            return Object.values(decisionsModule.selectedDecisionUsers)
                .filter(u => u.permissionAccess === 'OWNER' || u.permissionAccess === 'ADMIN')
                .map(u => u.userId);
        }
        return [];
    }

    get userId(): string | undefined {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return undefined;
    }

    get modifiedHeaders() {
        // Add an Actions column for Admins
        if (!this.decisionAdminUsers.includes(this.userId) || this.userList.length == 1) return this.headers;
        let res: any[] = [{text: 'Remove', value: 'actions', sortable: false, width: '60px', align: 'center'}]
        return res.concat(this.headers);
    }

    get userList(): any[] {
        //TODO: Remove anonymous users from the users database/decision
        //Temp solution - filter out users without emails (Anonymous users) 
        let users: any[] = Object.values(decisionsModule.selectedDecisionUsers).filter((user) => user.email);
        // add "role" based on Admin or not
        for (const user of users) {
            if (user.status === 'PENDING') {
                user.role = 'PENDING'
            } else if (user.permissionAccess) {
                user.role = user.permissionAccess;
            } else {
                user.role = 'USER';
            }
        }
        return users;
    }

    private async removeUser(user: any) {
        // set the "removing flag" to true and redraw the data table
        Vue.set(this.deletingMap, user.userId, true);
        try {
            // remove the User, set the removing flag to false and redraw the table
            if (user.status === 'PENDING') {
                await decisionsModule.removeUserFromDecisionByEmail(user.email);
            } else {
                await decisionsModule.removeUserFromDecision(user.userId);
            }
        } catch (err) {
            console.log(err);
        }
        Vue.set(this.deletingMap, user.userId, false)
    }

    private async updatePermission(userId: string, permissionAccess: string) {
        Vue.set(this.updatingMap, userId, true);
        await decisionsModule.changeUserPermissionAccess({userId: userId, permissionAccess: permissionAccess})
        Vue.delete(this.updatingMap, userId);
    }

    private getRoleText(role: string) {
        if (role === 'OWNER') return 'Owner';
        if (role === 'PENDING') return "Invite Sent"
        let foundRole = this.roles.find(r => r.value === role)
        if (foundRole) return foundRole.display;
        return ''
    }

    get currentUserRole() {
        return decisionsModule.selectedDecisionUsers[this.userId]?.permissionAccess

    }
}

